import { SleepingCowImage } from '@app/icons';

const NoStatements = () => {
  return (
    <div className="h-[400px] w-full px-6 py-8 bg-white rounded-lg flex-col justify-center items-center gap-4 inline-flex">
      <SleepingCowImage style={{ height: 128, width: 115 }} />
      <div className="flex-col gap-2 inline-flex">
        <div className="text-center text-navy-700 text-h6">No statements.</div>
        <div className="text-center text-navy-600 text-body2">
          There are currently no statements.
        </div>
      </div>
    </div>
  );
};

export default NoStatements;
